import "./NodeContent.less";

import { Icon, Badge } from "antd";
import React from "react";

import { IBaseProps } from "lib/data/interfaces";
import { ComponentTemplate, MultipleItemRequirement, Section, SectionTemplate, SingleItemRequirement } from "lib/data/model";
import { IconType } from "lib/data/model/dictionaries/IconTypes";

import { ButtonStateSwitch, DeleteButton, RightsEditButton } from "components/general/StandardButtons";
import { MiniTemplateCard } from "components/general/TemplateCard";
import { AddNode } from "../../AddNode";
import { SectionOwnersModal } from "./SectionOwnersModal";


interface INodeContentProps extends IBaseProps {
	title: string;
	subTitle: string;
	section: Section;
	parentSection?: Section;
	isDraft?: boolean;
	canDelete?: boolean;
	onSave: (value: string) => void;
	onDelete: (section: Section) => void;
}

interface INodeContentState {
	isDraft: boolean;
	canDelete: boolean;
	selected: boolean;
	buttonSelected?: "edit-settings-delete" | "edit-title";
	item: any;
	selectedTemplate: any;
}


export class NodeContent extends React.Component<INodeContentProps, INodeContentState> {

	private sectionTemplates: SectionTemplate[] = [];

	public constructor(props: INodeContentProps) {

		super(props);

		this.state = {
			isDraft: (this.props.isDraft === undefined || !this.props.isDraft ? false : true),
			canDelete: (this.props.canDelete === undefined || this.props.canDelete ? true : false),
			selected: false,
			buttonSelected: "edit-settings-delete",
			item: this.props.section,
			selectedTemplate: null,
		};
	}

	public componentWillMount = () => {

		this.setupTemplateObjects();
	}

	public componentWillReceiveProps(newProps: INodeContentProps) {

		// Check For Change In Draft Mode
		if (newProps.isDraft !== this.props.isDraft) {

			// Check Draft Mode
			if (newProps.isDraft !== undefined) {

				// Set New Draft State
				this.setState({ isDraft: newProps.isDraft });
			}
			else {

				// Set New Draft State
				this.setState({ isDraft: false });
			}
		}

		// Check For Change In 'Can Delete' Mode
		if (newProps.canDelete !== this.props.canDelete) {

			// Check Draft Mode
			if (newProps.canDelete !== undefined) {

				// Set New Draft State
				this.setState({ canDelete: newProps.canDelete });
			}
			else {

				// Set New Draft State
				this.setState({ canDelete: true });
			}
		}
	}

	public render() {

		// Define Class Name(s)
		const className = [
			"node-content",
			this.props.className
		].filter((v) => v !== undefined && v !== null).join(" ");

		return (
			<div className={className}>

				<div className="node-details">

					{this.props.isDraft ?
						<div className="node-title-wrapper node-draft">
							<h3 className="node-title">{this.props.title}</h3>
							<Badge offset={[20, -17.5]} count={<div className="unpublished-section-badge">unpublished</div>} />
							<h6 className="node-subtitle">- {this.props.subTitle}</h6>
						</div>
						:
						<div className="node-title-wrapper">
							<h3 className="node-title">{this.props.title}</h3>
							<h6 className="node-subtitle">- {this.props.subTitle}</h6>
						</div>
					}

					<ButtonStateSwitch on="edit-settings-delete" in={this.state.buttonSelected}>
						<div className="edit-settings-delete">
							<RightsEditButton onClick={this.openModal} />
							{(
								this.state.canDelete
									?
									<DeleteButton onClick={this.onDelete} />
									:
									null
							)}
						</div>
					</ButtonStateSwitch>

					<ButtonStateSwitch on="edit-title" in={this.state.buttonSelected} >
						<div className="edit-title">
							<AddNode
								isActive={this.state.buttonSelected === "edit-title"}
								closeEdit={() => this.setState({ buttonSelected: "edit-settings-delete" })}
								defaultValue={this.props.title}
								onSave={this.onTitleSave}
							/>
						</div>
					</ButtonStateSwitch>


					<ButtonStateSwitch className="" on="" in={this.state.buttonSelected}>
						<div className="mini-card-wrapper">
							{this.sectionTemplates.map((template, key) =>
								<MiniTemplateCard
									key={key}
									onClick={() => this.selectNewTempate(template.id!)}
									selected={this.state.item.templateId === template.id}
									showCheckboxes={false}
									title={template.name}
									iconType={IconType.get(template.$type)}
									className="mini-card"
								/>
							)}
						</div>
					</ButtonStateSwitch>
				</div>

				<SectionOwnersModal selected={this.state.selected} section={this.props.section} closeModal={this.closeModal} />
			</div>
		);
	}

	private setupTemplateObjects = () => {

		if (this.props.parentSection !== undefined) {

			const sectionTemplates: SectionTemplate[] = [];

			this.props.parentSection.template.requirements.forEach((requirement) => {

				switch (requirement.$type) {

					case SingleItemRequirement.$type.ComponentTemplate:
						const singleItemRequirement = requirement as SingleItemRequirement<ComponentTemplate>;

						if (singleItemRequirement.item.item.$type === "SectionTemplate") {

							const sectionTemplate = singleItemRequirement.item.item as SectionTemplate;
							sectionTemplates.push(sectionTemplate);
						}

						break;

					case MultipleItemRequirement.$type.ComponentTemplate:

						const multipleItemRequirement = requirement as MultipleItemRequirement<ComponentTemplate>;

						multipleItemRequirement.items.forEach((requirementItem) => {

							if (requirementItem.item.$type === "SectionTemplate") {

								const sectionTemplate = requirementItem.item as SectionTemplate;
								sectionTemplates.push(sectionTemplate);
							}
						});

						break;

					default:

						break;
				}

				this.sectionTemplates = sectionTemplates;
			});
		}
	}

	private onTitleSave = (value: string) => {

		this.setState({ buttonSelected: "edit-settings-delete", selectedTemplate: null });
		this.props.onSave(value);
	}

	private closeModal = () => {

		this.setState({ selected: false });
	}

	private openModal = () => {

		this.setState({ selected: true });
	}

	private selectNewTempate = (id: number | null) => {

		if (id) {

			const sectionTemplate: SectionTemplate = this.sectionTemplates.filter((template) => template.id === id)[0];
			this.setState({ selectedTemplate: sectionTemplate });
		}

		this.setState({ buttonSelected: "edit-title" });
	}

	private onDelete = () => {

		if (this.props.onDelete) {

			this.props.onDelete(this.props.section);
		}
	}
}
